export const comercios = [{
  id: '1',
  name: 'Comercio 1',
  countEmployees: 2,
  countTerminals: 3,
  direction: 'Calle Zurbaran 2'
}, {
  id: '2',
  name: 'Comercio 2',
  countEmployees: 2,
  countTerminals: 2,
  direction: 'Calle Zurbaran 3'
}, {
  id: '3',
  name: 'Comercio 3',
  countEmployees: 23,
  countTerminals: 24,
  direction: 'Calle Zurbaran 4'
}, {
  id: '4',
  name: 'Comercio 4',
  countEmployees: 33,
  countTerminals: 33,
  direction: 'Calle Zurbaran 5'
}, {
  id: '5',
  name: 'Comercio 5',
  countEmployees: 43,
  countTerminals: 44,
  direction: 'Calle Zurbaran 7'
}, {
  id: '6',
  name: 'Comercio 6',
  countEmployees: 53,
  countTerminals: 35,
  direction: 'Calle Zurbaran 11'
}, {
  id: '7',
  name: 'Comercio 7',
  countEmployees: 53,
  countTerminals: 35,
  direction: 'Calle Zurbaran 11'
}, {
  id: '8',
  name: 'Comercio 8',
  countEmployees: 53,
  countTerminals: 35,
  direction: 'Calle Zurbaran 11'
}, {
  id: '9',
  name: 'Comercio 9',
  countEmployees: 53,
  countTerminals: 35,
  direction: 'Calle Zurbaran 11'
}
]
